module.exports = __webpack_public_path__ + "img/convert-to-case-white.595aba2a.svg";